import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/IntroText.css";

const IntroText = props => {

     return props.size === "laptopdesktop" ? (
          <div className="introductionBackground">

               <div style={{ paddingTop: "125px" }}>
                    <Center>
                         <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft" style={{color:"#fff",boxShadow: "5px",}}><strong>معرفی ایرانیان پوشش</strong></p>
                    </Center>
                    <Center>
                         <Margin top={2}>
                              <p className="mainTitleDescription" style={{color:"#fff"}}>هر آنچه باید در مورد ایرانیان پوشش بدانید</p>
                         </Margin>
                    </Center>
               </div>
               <div>
                    <Row style={{ marginTop: "100px" }}>
                         <Col span={4}></Col>
                         <Col span={16}>
                              <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",opacity:"90%", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                   <div style={{ borderRadius: "20px 20px 0 0" }}>
                                        <Center>
                                             <Margin top={4}>
                                                  <div>
                                                       <p className="cardTitle"><strong>ما ایرانیان پوشش هستیم</strong></p>
                                                  </div>
                                             </Margin>
                                        </Center>
                                        <Center>
                                             <hr className="cardTitleHR" />
                                        </Center>
                                   </div>
                                   <Margin top={2}></Margin>
                                   <div style={{ paddingRight: "30px", paddingLeft: '30px' }}>
                                        <p className="textParagraph">
                                             نزدیک به 80 سال از آغاز فعالیت صنعت بیمه در ایران میگذرد در طی این 8 دهه عمده تمرکز شرکت های بیمه ای در زمینه ای فروش و بازاریابی بیمه در کشور بوده است اما با تمام تلاش های بی شائبه انجام گرفته توسط مدیران عالی و میانی صنعت بیمه هنوز فاصله قابل ملاحظه ای ضریب نفوذ بیمه در ایران با میانگین جهانی وجود دارد و از طرفی همزمان با جهانی شدن اقتصاد , عصر اطلاعات و دانش , رشد بی سابقه ضرب آهنگ صنایع و از طرفی تغییر جهت رویکرد بازار و خدمات از سمت مشتری به محصول و تولید محصولات و ارائه خدمات متناسب با نیازمندی های مشتری و ظهور شرکت های استارت تاپی , کلیه صنایع تولیدی و خدماتی را به تغییر رویکرد و استراتژی مجبور می‌نماید, صنعت بیمه که نقشی اساسی و پایه ای در حفظ ثروت ملی , رونق اقتصادی و کمک به توسعه ای سایر صنایع دارد ,  از این تغییرات جدا نیست و می‌بایست دوچندان استراتژی‌های کلان خود را متناسب با نیاز جامعه و اقدام به چابک سازی فرآیندهای عملیاتی نماید.
                                        </p>
                                        <p className="textBoldParagraph">
                                             <strong>
                                                  هلدینگ ایرانیان پوشش با شناسائی  نقاط ضعف و قوت و موانع و چالش‌های پیش روی توسعه صنعت بیمه , با عنایت و توکل به خداوند , توانست در سال ۱۳۹۱ مصادف با سال تولید ملی , حمایت از کار و سرمایه ایرانی و در لبیک به فرمایش مقام معظم رهبری ایده ایستگاه نوآوری تخصصی بیمه ای منهای فروش را ؛ راه اندازی  و در روز بیمه (دقیقاً در سیزده آذر سال 1391) به میمنت و مبارکی این روز ثبت برند و شرکت تاسیس نمايد.
                                             </strong>
                                        </p>
                                        <p className="textParagraph">
                                             اهداف عالی موسسین  هلدینگ ایرانیان پوشش  , تاسیس و راه اندازی 12 شرکت تخصصی و حرفه ای در صنعت بیمه (منهای فروش)  با موضوعات : ارزیابی خسارت بیمه ای ، ریسک ، ایمنی ، آکچوئری ، داده کاوی ، آموزش ، پژوهش ، ریکاوری ، داوری ، رسانه ، تحقیق ، بازرسی ، حسابرسی ، حقوقي و وکالت بيمه گران ، مشاوره ، امداد و کمک‌رسان ، تکنولوژی و فن‌آوری‌اطلاعات است .
                                             باور قلبی و ذهنی ما در هلدینگ ایرانیان پوشش  از آغاز کار شعار "مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار)" است  و از همان ابتدا، برای تضمین حقوق بیمه گر و   بیمه گذار همراه با نوآوری و خلاقیت در ارائه خدمات تخصصی ,  چهار اصل حرفه ای و حیاتی :
<br />
1)  استقلال و بی طرفی
                                             <br />

2)  دقت توام با سرعت عمل
                                             <br />

3)  امانت داری  و حفظ راز کسب و کار
                                             <br />

4)  رعایت اخلاق حرفه ای
                                             <br />

 را سرلوحه خدمات تخصصی خود قرار داد.
<br />
ایستگاه نوآوری ایرانیان پوشش شامل 12 زیرمجموعه و شرکت ذیل است :
<br/>
1)  شرکت ارزیابان ایرانیان پوشش (شرکت جامع ارزیابی خسارت و ریسک بیمه ای)
                                             <br />

2) مراقب بیمه (رسانه و رادیو تخصصی بیمه)
                                             <br />

3) دادگر بیمه
                                             <br />

4) دادرس بیمه
                                             <br />

5) اندیشکده بیمه
                                             <br />

6) کنکاش بیمه
                                             <br />

7) آموزشگاه فنی و حرفه ای آزاد ایرانیان پوشش
                                             <br />

8) افسران تحقیق (همیار بیمه)
                                             <br />

9) امداد و نجات 
                                             <br />

10) شرکت ایمن دیار
                                             <br />

11) شرکت نرم افزاری سناپ
                                             <br />

12) موسسه حسابرسی بیمه ای امین پوشش
<br />
یکی از استراتژی‌های کلان هلدینگ ایرانیان پوشش , گسترش ارائه خدمات کلیه شرکت های تحت پوشش در اقصی نقاط ایران عزیز تا سال 1401 بود از این جهت شماره تماس 24 ساعته شرکت بشماره 1401 بدون کد بصورت خلاقانه راه اندازی نمود تا هدف سال١٤٠١ ملكه ذهن کارشناسان و مدیران سازمان خود گردد.
                                             <br />

مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره بی‌بدیل سرمایه های اجتماعی و انسانی ارزشمند خود و هچنین دانش و زیرساخت های مناسب مي‌تواند ، به مثابه نهادی حرفه‌ای برای بیمه‌گران ،   بیمه گذاران و همچنین نهادهای سیاست‌گذار صنعت بیمه , اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی‌اش با عرضه خدمات با‌کیفیت و صادقانه در زمینه تخصصی بیمه ,  علی الخصوص در حوزه ارزیابی خسارت و ریسک اعتماد آن‌ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب نماید.
                                             <br />

موسس , ايده پرداز و بومی سازي هلدينگ ایرانیان پوشش توسط دکتر ابراهيم ايران نژاد در عنفوان جوانی و در سن 30 سالگي كليد خورد. ایشان از همان ابتدا بعنوان بنيانگذار و مديرعامل شركت و با حفظ سمت ريس هيات مديره کلیه شركت هاي تحت پوشش توسط اعضاي هيات مديره شركت‌ها انتخاب گرديدند.
                                             <br />

دکتر ابراهیم ايران نژاد در طراحي و راه‌اندازی اين هلدينگ اقدامات سنگین ذیل را با همکاری سایر همکاران فرهیخته خود اقدامات ذیل را اجرا نمودند :

فرآیند اخذ مجوزهای قانونی شرکت ها , مطالعه و تحقیق در زمینه بازار محصولات و خدمات هر شرکت , مدل‌های درآمدی و عملیاتی هر شرکت , تحلیل رقابتی بازار , جذب و شناسایی مشتری , تامین مالی , طراحی و پیاده سازی فرآیندهای کاری و عملیاتی , طراحی چارت سازمانی و جذب نیروهای متخصص و معتمد , شناسایی تهدیدها و فرصت های پیش رو , تحلیل و کسب سهم بازار صدور و خسارت صنعت بیمه به تفکیک رشته ای بیمه ای و در استان های مختلف و همچنین بررسی الگوها و مدل های موفق در کشورهای توسعه یافته.

                                        </p>
                                   </div>
                              </div>
                         </Col>
                         <Col span={4}></Col>
                    </Row>
               </div>
          </div>
     ) : props.size === "tablet" ? (
               <div className="introductionBackground">

                    <div style={{ paddingTop: "50px" }}>
                         <Center>
                              <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft" style={{color:"#fff"}}><strong>معرفی ایرانیان پوشش</strong></p>
                         </Center>
                         <Center>
                              <Margin top={2}>
                                   <p className="mainTitleDescriptionTablet" style={{ color: "#fff" }}>هر آنچه باید در مورد ایرانیان پوشش بدانید</p>
                              </Margin>
                         </Center>
                    </div>
                    <div>
                         <Row style={{ marginTop: "150px" }}>
                              <Col span={2}></Col>
                              <Col span={20}>
                                   <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                        <div style={{ backgroundColor: "#f6f6f6", borderRadius:"20px 20px 0 0" }}>
                                             <Center>
                                                  <Margin top={4}>
                                                       <div>
                                                            <p className="cardTitleTablet"><strong>ما ایرانیان پوشش هستیم</strong></p>
                                                       </div>
                                                  </Margin>
                                             </Center>
                                             <Center>
                                                  <hr className="cardTitleHRTablet" />
                                             </Center>
                                        </div>
                                        <Margin top={2}></Margin>
                                        <div style={{ paddingRight: "30px", paddingLeft: '30px' }}>
                                             <p className="textParagraphTablet">
                                                  نزدیک به 80 سال از آغاز فعالیت صنعت بیمه در ایران میگذرد در طی این 8 دهه عمده تمرکز شرکت های بیمه ای در زمینه ای فروش و بازاریابی بیمه در کشور بوده است اما با تمام تلاش های بی شائبه انجام گرفته توسط مدیران عالی و میانی صنعت بیمه هنوز فاصله قابل ملاحظه ای ضریب نفوذ بیمه در ایران با میانگین جهانی وجود دارد و از طرفی همزمان با جهانی شدن اقتصاد , عصر اطلاعات و دانش , رشد بی سابقه ضرب آهنگ صنایع و از طرفی تغییر جهت رویکرد بازار و خدمات از سمت مشتری به محصول و تولید محصولات و ارائه خدمات متناسب با نیازمندی های مشتری و ظهور شرکت های استارت تاپی , کلیه صنایع تولیدی و خدماتی را به تغییر رویکرد و استراتژی مجبور می‌نماید, صنعت بیمه که نقشی اساسی و پایه ای در حفظ ثروت ملی , رونق اقتصادی و کمک به توسعه ای سایر صنایع دارد ,  از این تغییرات جدا نیست و می‌بایست دوچندان استراتژی‌های کلان خود را متناسب با نیاز جامعه و اقدام به چابک سازی فرآیندهای عملیاتی نماید.
                                        </p>
                                             <p className="textBoldParagraphTablet">
                                                  <strong>
                                                       هلدینگ ایرانیان پوشش با شناسائی  نقاط ضعف و قوت و موانع و چالش‌های پیش روی توسعه صنعت بیمه , با عنایت و توکل به خداوند , توانست در سال ۱۳۹۱ مصادف با سال تولید ملی , حمایت از کار و سرمایه ایرانی و در لبیک به فرمایش مقام معظم رهبری ایده ایستگاه نوآوری تخصصی بیمه ای منهای فروش را ؛ راه اندازی  و در روز بیمه (دقیقاً در سیزده آذر سال 1391) به میمنت و مبارکی این روز ثبت برند و شرکت تاسیس نمايد.
                                             </strong>
                                             </p>
                                             <p className="textParagraphTablet">
                                                  اهداف عالی موسسین  هلدینگ ایرانیان پوشش  , تاسیس و راه اندازی 12 شرکت تخصصی و حرفه ای در صنعت بیمه (منهای فروش)  با موضوعات : ارزیابی خسارت بیمه ای ، ریسک ، ایمنی ، آکچوئری ، داده کاوی ، آموزش ، پژوهش ، ریکاوری ، داوری ، رسانه ، تحقیق ، بازرسی ، حسابرسی ، حقوقي و وکالت بيمه گران ، مشاوره ، امداد و کمک‌رسان ، تکنولوژی و فن‌آوری‌اطلاعات است .
                                                  باور قلبی و ذهنی ما در هلدینگ ایرانیان پوشش  از آغاز کار شعار "مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار)" است  و از همان ابتدا، برای تضمین حقوق بیمه گر و   بیمه گذار همراه با نوآوری و خلاقیت در ارائه خدمات تخصصی ,  چهار اصل حرفه ای و حیاتی :
<br />
1)  استقلال و بی طرفی
                                             <br />

2)  دقت توام با سرعت عمل
                                             <br />

3)  امانت داری  و حفظ راز کسب و کار
                                             <br />

4)  رعایت اخلاق حرفه ای
                                             <br />

 را سرلوحه خدمات تخصصی خود قرار داد.
<br />
ایستگاه نوآوری ایرانیان پوشش شامل 12 زیرمجموعه و شرکت ذیل است :
<br />

1)  شرکت ارزیابان ایرانیان پوشش (شرکت جامع ارزیابی خسارت و ریسک بیمه ای)
                                             <br />

2) مراقب بیمه (رسانه و رادیو تخصصی بیمه)
                                             <br />

3) دادگر بیمه
                                             <br />

4) دادرس بیمه
                                             <br />

5) اندیشکده بیمه
                                             <br />

6) کنکاش بیمه
                                             <br />

7) آموزشگاه فنی و حرفه ای آزاد ایرانیان پوشش
                                             <br />

8) افسران تحقیق (همیار بیمه)
                                             <br />

9) امداد و نجات 
                                             <br />

10) شرکت ایمن دیار
                                             <br />

11) شرکت نرم افزاری سناپ
                                             <br />

12) موسسه حسابرسی بیمه ای امین پوشش
<br />
یکی از استراتژی‌های کلان هلدینگ ایرانیان پوشش , گسترش ارائه خدمات کلیه شرکت های تحت پوشش در اقصی نقاط ایران عزیز تا سال 1401 بود از این جهت شماره تماس 24 ساعته شرکت بشماره 1401 بدون کد بصورت خلاقانه راه اندازی نمود تا هدف سال١٤٠١ ملكه ذهن کارشناسان و مدیران سازمان خود گردد.
                                             <br />

مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره بی‌بدیل سرمایه های اجتماعی و انسانی ارزشمند خود و هچنین دانش و زیرساخت های مناسب مي‌تواند ، به مثابه نهادی حرفه‌ای برای بیمه‌گران ،   بیمه گذاران و همچنین نهادهای سیاست‌گذار صنعت بیمه , اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی‌اش با عرضه خدمات با‌کیفیت و صادقانه در زمینه تخصصی بیمه ,  علی الخصوص در حوزه ارزیابی خسارت و ریسک اعتماد آن‌ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب نماید.
                                             <br />

موسس , ايده پرداز و بومی سازي هلدينگ ایرانیان پوشش توسط دکتر ابراهيم ايران نژاد در عنفوان جوانی و در سن 30 سالگي كليد خورد. ایشان از همان ابتدا بعنوان بنيانگذار و مديرعامل شركت و با حفظ سمت ريس هيات مديره کلیه شركت هاي تحت پوشش توسط اعضاي هيات مديره شركت‌ها انتخاب گرديدند.
                                             <br />

دکتر ابراهیم ايران نژاد در طراحي و راه‌اندازی اين هلدينگ اقدامات سنگین ذیل را با همکاری سایر همکاران فرهیخته خود اقدامات ذیل را اجرا نمودند :

فرآیند اخذ مجوزهای قانونی شرکت ها , مطالعه و تحقیق در زمینه بازار محصولات و خدمات هر شرکت , مدل‌های درآمدی و عملیاتی هر شرکت , تحلیل رقابتی بازار , جذب و شناسایی مشتری , تامین مالی , طراحی و پیاده سازی فرآیندهای کاری و عملیاتی , طراحی چارت سازمانی و جذب نیروهای متخصص و معتمد , شناسایی تهدیدها و فرصت های پیش رو , تحلیل و کسب سهم بازار صدور و خسارت صنعت بیمه به تفکیک رشته ای بیمه ای و در استان های مختلف و همچنین بررسی الگوها و مدل های موفق در کشورهای توسعه یافته.

                                        </p>
                                        </div>
                                   </div>
                              </Col>
                              <Col span={2}></Col>
                         </Row>
                    </div>
               </div>

     ) : (
                    <div>
                         <div className="introductionBackground">

                              <div style={{ paddingTop: "25px" }}>
                                   <Center>
                                        <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile" style={{color:"#fff"}}><strong>معرفی ایرانیان پوشش</strong></p>
                                   </Center>
                                   <Center>
                                        <Margin top={2}>
                                             <p className="mainTitleDescriptionMobile" style={{ color: "#fff" , textAlign:"center" }}>هر آنچه باید در مورد ایرانیان پوشش بدانید</p>
                                        </Margin>
                                   </Center>
                              </div>
                              <div>
                                   <Row style={{ marginTop: "25px" }}>
                                        <Col span={1}></Col>
                                        <Col span={22}>
                                             <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                                  <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                                       <Center>
                                                            <Margin top={4}>
                                                                 <div>
                                                                      <p className="cardTitleMobile"><strong>ما ایرانیان پوشش هستیم</strong></p>
                                                                 </div>
                                                            </Margin>
                                                       </Center>
                                                       <Center>
                                                            <div className="cardTitleHR"></div>
                                                       </Center>
                                                       <Margin top={2}></Margin>
                                                       <div style={{ paddingRight: "15px", paddingLeft: '15px',backgroundColor:"#fff"  }}>
                                                            <p className="textParagraphMobile" style={{paddingTop:"10px"}}>
                                                                 نزدیک به 80 سال از آغاز فعالیت صنعت بیمه در ایران میگذرد در طی این 8 دهه عمده تمرکز شرکت های بیمه ای در زمینه ای فروش و بازاریابی بیمه در کشور بوده است اما با تمام تلاش های بی شائبه انجام گرفته توسط مدیران عالی و میانی صنعت بیمه هنوز فاصله قابل ملاحظه ای ضریب نفوذ بیمه در ایران با میانگین جهانی وجود دارد و از طرفی همزمان با جهانی شدن اقتصاد , عصر اطلاعات و دانش , رشد بی سابقه ضرب آهنگ صنایع و از طرفی تغییر جهت رویکرد بازار و خدمات از سمت مشتری به محصول و تولید محصولات و ارائه خدمات متناسب با نیازمندی های مشتری و ظهور شرکت های استارت تاپی , کلیه صنایع تولیدی و خدماتی را به تغییر رویکرد و استراتژی مجبور می‌نماید, صنعت بیمه که نقشی اساسی و پایه ای در حفظ ثروت ملی , رونق اقتصادی و کمک به توسعه ای سایر صنایع دارد ,  از این تغییرات جدا نیست و می‌بایست دوچندان استراتژی‌های کلان خود را متناسب با نیاز جامعه و اقدام به چابک سازی فرآیندهای عملیاتی نماید.
                                        </p>
                                                            <p className="textBoldParagraphMobile">
                                                                 <strong>
                                                                      هلدینگ ایرانیان پوشش با شناسائی  نقاط ضعف و قوت و موانع و چالش‌های پیش روی توسعه صنعت بیمه , با عنایت و توکل به خداوند , توانست در سال ۱۳۹۱ مصادف با سال تولید ملی , حمایت از کار و سرمایه ایرانی و در لبیک به فرمایش مقام معظم رهبری ایده ایستگاه نوآوری تخصصی بیمه ای منهای فروش را ؛ راه اندازی  و در روز بیمه (دقیقاً در سیزده آذر سال 1391) به میمنت و مبارکی این روز ثبت برند و شرکت تاسیس نمايد.
                                             </strong>
                                                            </p>
                                                            <p className="textParagraphMobile">
                                                                 اهداف عالی موسسین  هلدینگ ایرانیان پوشش  , تاسیس و راه اندازی 12 شرکت تخصصی و حرفه ای در صنعت بیمه (منهای فروش)  با موضوعات : ارزیابی خسارت بیمه ای ، ریسک ، ایمنی ، آکچوئری ، داده کاوی ، آموزش ، پژوهش ، ریکاوری ، داوری ، رسانه ، تحقیق ، بازرسی ، حسابرسی ، حقوقي و وکالت بيمه گران ، مشاوره ، امداد و کمک‌رسان ، تکنولوژی و فن‌آوری‌اطلاعات است .
                                                                 باور قلبی و ذهنی ما در هلدینگ ایرانیان پوشش  از آغاز کار شعار "مراقب بیمه (حافظ رابطه بیمه گر و   بیمه گذار)" است  و از همان ابتدا، برای تضمین حقوق بیمه گر و   بیمه گذار همراه با نوآوری و خلاقیت در ارائه خدمات تخصصی ,  چهار اصل حرفه ای و حیاتی :
<br />
1)  استقلال و بی طرفی
                                             <br />

2)  دقت توام با سرعت عمل
                                             <br />

3)  امانت داری  و حفظ راز کسب و کار
                                             <br />

4)  رعایت اخلاق حرفه ای
                                             <br />

 را سرلوحه خدمات تخصصی خود قرار داد.
<br />
ایستگاه نوآوری ایرانیان پوشش شامل 12 زیرمجموعه و شرکت ذیل است :
<br/>
1)  شرکت ارزیابان ایرانیان پوشش (شرکت جامع ارزیابی خسارت و ریسک بیمه ای)
                                             <br />

2) مراقب بیمه (رسانه و رادیو تخصصی بیمه)
                                             <br />

3) دادگر بیمه
                                             <br />

4) دادرس بیمه
                                             <br />

5) اندیشکده بیمه
                                             <br />

6) کنکاش بیمه
                                             <br />

7) آموزشگاه فنی و حرفه ای آزاد ایرانیان پوشش
                                             <br />

8) افسران تحقیق (همیار بیمه)
                                             <br />

9) امداد و نجات 
                                             <br />

10) شرکت ایمن دیار
                                             <br />

11) شرکت نرم افزاری سناپ
                                             <br />

12) موسسه حسابرسی بیمه ای امین پوشش
<br />
یکی از استراتژی‌های کلان هلدینگ ایرانیان پوشش , گسترش ارائه خدمات کلیه شرکت های تحت پوشش در اقصی نقاط ایران عزیز تا سال 1401 بود از این جهت شماره تماس 24 ساعته شرکت بشماره 1401 بدون کد بصورت خلاقانه راه اندازی نمود تا هدف سال١٤٠١ ملكه ذهن کارشناسان و مدیران سازمان خود گردد.
                                             <br />

مجموعه شرکت های ایرانیان پوشش به پشتوانه ذخیره بی‌بدیل سرمایه های اجتماعی و انسانی ارزشمند خود و هچنین دانش و زیرساخت های مناسب مي‌تواند ، به مثابه نهادی حرفه‌ای برای بیمه‌گران ،   بیمه گذاران و همچنین نهادهای سیاست‌گذار صنعت بیمه , اعتمادآور و اطمینان بخش باشد و در پرتو مسئولیت اجتماعی‌اش با عرضه خدمات با‌کیفیت و صادقانه در زمینه تخصصی بیمه ,  علی الخصوص در حوزه ارزیابی خسارت و ریسک اعتماد آن‌ها را بیش از پیش به توانمندی ها و قابلیت هایش جلب نماید.
                                             <br />

موسس , ايده پرداز و بومی سازي هلدينگ ایرانیان پوشش توسط دکتر ابراهيم ايران نژاد در عنفوان جوانی و در سن 30 سالگي كليد خورد. ایشان از همان ابتدا بعنوان بنيانگذار و مديرعامل شركت و با حفظ سمت ريس هيات مديره کلیه شركت هاي تحت پوشش توسط اعضاي هيات مديره شركت‌ها انتخاب گرديدند.
                                             <br />

دکتر ابراهیم ايران نژاد در طراحي و راه‌اندازی اين هلدينگ اقدامات سنگین ذیل را با همکاری سایر همکاران فرهیخته خود اقدامات ذیل را اجرا نمودند :

فرآیند اخذ مجوزهای قانونی شرکت ها , مطالعه و تحقیق در زمینه بازار محصولات و خدمات هر شرکت , مدل‌های درآمدی و عملیاتی هر شرکت , تحلیل رقابتی بازار , جذب و شناسایی مشتری , تامین مالی , طراحی و پیاده سازی فرآیندهای کاری و عملیاتی , طراحی چارت سازمانی و جذب نیروهای متخصص و معتمد , شناسایی تهدیدها و فرصت های پیش رو , تحلیل و کسب سهم بازار صدور و خسارت صنعت بیمه به تفکیک رشته ای بیمه ای و در استان های مختلف و همچنین بررسی الگوها و مدل های موفق در کشورهای توسعه یافته.

                                        </p>
                                                       </div>
                                                  </div>
                                             </div>
                                        </Col>
                                        <Col span={1}></Col>
                                   </Row>
                              </div>
                         </div>
                    </div>
               );
};

export default IntroText;
